import { fromUnixTime, format } from "date-fns";
import { enUS as en, ja, ko } from "date-fns/locale";

export default function (value, dateFormat = "yyyy mm", unixTimeFlag = true, locale) {
  const formatLocale = { en, ja, ko };
  if (!value) {
    return "-";
  }
  if (unixTimeFlag) {
    value = fromUnixTime(value);
  }
  return format(value, dateFormat, { locale: formatLocale[locale] });
}
